import { MapPin, ArrowUpRight } from "lucide-react";
import { useLang } from "../../context/LanguageContext";
import { Ed, Reveal } from "../Editorial";
import { STUDIO, mapsDirectionsUrl } from "../../constants/contact";
import { StudioMap } from "./StudioMap";

export const LocationSection = () => {
  const { lang, t } = useLang();
  const l = t.location;
  const lines = STUDIO.addressLines[lang] || STUDIO.addressLines.es;

  return (
    <section id="location" className="px-6 md:px-16 py-24 md:py-40 border-t border-white/10" data-testid="location-section">
      <Reveal>
        <p className="overline-gold font-sans">
          <Ed text={l.overline} goldItalic={false} />
        </p>
        <h2 className="mt-8 font-serif text-4xl md:text-6xl text-white">
          <Ed text={l.heading} />
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-12 lg:grid-cols-5 items-stretch">
        {/* Detalles */}
        <Reveal className="lg:col-span-2 flex flex-col justify-center">
          <p className="overline-gold">{l.addressLabel}</p>
          <div className="mt-5 flex items-start gap-3">
            <MapPin size={18} className="mt-1 shrink-0 text-[#C5A059]" />
            <p className="font-serif text-2xl md:text-3xl text-white leading-snug">
              {lines.map((line, i) => (
                <span key={i} className="block">{line}</span>
              ))}
            </p>
          </div>

          <div className="mt-8 space-y-1 text-sm text-zinc-500 font-light">
            <p className="overline-gold mb-3 !text-zinc-400">{t.footer.hours}</p>
            <p>{t.footer.hoursWeek}</p>
            <p>{t.footer.hoursWeekend}</p>
          </div>

          <a
            href={mapsDirectionsUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="directions-btn"
            className="btn-gold mt-10 w-fit inline-flex items-center gap-2 !px-7"
          >
            {l.directions}
            <ArrowUpRight size={15} />
          </a>
          <p className="mt-4 text-[0.7rem] text-zinc-600 italic">{l.provisional}</p>
        </Reveal>

        {/* Mapa */}
        <Reveal delay={0.1} className="lg:col-span-3">
          <StudioMap label={l.overline.replace(/\*/g, "")} directions={l.directions} fachada={l.storefront} />
        </Reveal>
      </div>
    </section>
  );
};
